/* eslint-disable no-console */
import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class FatturazioneService {
  constructor(http, eventBus) {
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_pratiche.url}` 
    this.apiUrl = `${services.ask_api.url}/management`
    this.filemanager = new FileManager()
  }

  async getDataByRappresentante(codRapp, codAgente, consumo = null, typePay = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      if (typePay) params.typePay = typePay;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/data-by-rappresentante/${codRapp}/${codAgente}`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei dati per rappresentante:', error);
      throw error;
    }
  }

  async getDataByMese(mese, consumo = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/data-by-mese/${mese}`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei dati per mese:', error);
      throw error;
    }
  }
  async getAutoFattureDetail(numero) {
    try {
      const response = await this.http.get(
        `${this.apiUrl}/clienti/autofatture/${numero}/dettagli`
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei dettagli della fattura: '+numero, error);
      throw error;
    }
  }

  async getStatistichePerMese(consumo = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/statistiche-per-mese`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero delle statistiche per mese:', error);
      throw error;
    }
  }

  async getStatisticheByPagamento(consumo = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/statistiche-by-pagamento`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero delle statistiche per pagamento:', error);
      throw error;
    }
  }

  async getStatisticheByAgente(consumo = null, typePay = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      if (typePay) params.typePay = typePay;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/statistiche-by-agente`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero delle statistiche per agente:', error);
      throw error;
    }
  }

  async getDataByPay(pay, consumo = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/data-by-pay/${pay}`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei dati per tipo pagamento:', error);
      throw error;
    }
  }

  async getStatisticheRappresentantiByAgente(agente, consumo = null, typePay = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      if (typePay) params.typePay = typePay;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/statistiche-rappresentanti-by-agente/${agente}`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero delle statistiche dei rappresentanti per agente:', error);
      throw error;
    }
  }

  async getGroupedDataByRappresentante(codRapp) {
    try {
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/grouped-data-by-rappresentante/${codRapp}`,
        { params: {}, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei dati raggruppati per rappresentante:', error);
      throw error;
    }
  }

  async getDataByAgente(agenteId, consumo = null, typePay = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      if (typePay) params.typePay = typePay;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/data-by-agente/${agenteId}`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei dati per agente:', error);
      throw error;
    }
  }
  
  async getAllFattureByAgente(agenteId, agenteName, consumo = null, typePay = null) {
    const rappresentanti = await this.getStatisticheRappresentantiByAgente(
      agenteId,
      consumo,
      typePay
    );
    
    let allFatture = [];
    
    const mesiRecenti = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    for (const mese of mesiRecenti) {
      try {
        const fattureMese = await this.getDataByMese(mese, consumo);
        if (Array.isArray(fattureMese)) {
          const filtrate = fattureMese.filter(item => item.agente === agenteName);
          allFatture = [...allFatture, ...filtrate];
        }
      } catch (e) {
        console.warn(`Non è stato possibile caricare le fatture per il mese ${mese}`);
      }
    }
    
    allFatture = [...new Map(allFatture.map(item => [item.numero, item])).values()];
    
    if (allFatture.length === 0 && rappresentanti.length > 0) {
      for (const rappresentante of rappresentanti) {
        try {
          const fattureRappresentante = await this.getDataByRappresentante(
            rappresentante.cod_rapp,
            agenteId,
            consumo,
            typePay
          );
          if (Array.isArray(fattureRappresentante)) {
            allFatture = [...allFatture, ...fattureRappresentante];
          }
        } catch (e) {
          console.warn(`Non è stato possibile caricare le fatture per il rappresentante ${rappresentante.rappresentante}`);
        }
      }
      
      allFatture = [...new Map(allFatture.map(item => [item.numero, item])).values()];
    }
    
    return allFatture;
  }
  
  async downloadCsv(partitario = 'E', consumo = null, isPreview = false, isAuto = false) {
    try {
      const params = {
        partitario,
        ...(consumo && { consumo }),
        ...(isPreview && { preview: 1 }),
        ...(isAuto && { auto: 1 })
      };
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/download-csv`,
        { 
          params, 
          timeout: 30000,
          responseType: 'blob' 
        }
      );
      
      return response.data;
    } catch (error) {
      console.error('Errore durante il download del CSV:', error);
      throw error;
    }
  }
  
  async getRiepilogoFatturato(consumo = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/riepilogo-fatturato-mese`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero del riepilogo fatturato:', error);
      throw error;
    }
  }

    
  
  // INIZIO PARTE GAS
  async getGasDataByRappresentante(codRapp, codAgente, consumo = null, typePay = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      if (typePay) params.typePay = typePay;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/rappresentante/${codRapp}/${codAgente}`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei dati Gas per rappresentante:', error);
      throw error;
    }
  }
  
  async getGasDataByMese(mese, consumo = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/mese/${mese}`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei dati Gas per mese:', error);
      throw error;
    }
  }
  
  async getGasStatisticheByPagamento(consumo = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/statistiche/pagamento`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero delle statistiche Gas per pagamento:', error);
      throw error;
    }
  }
  
  async getGasStatisticheByAgente(consumo = null, typePay = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      if (typePay) params.typePay = typePay;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/statistiche/agente`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero delle statistiche Gas per agente:', error);
      throw error;
    }
  }
  
  async getGasDataByPay(pay, consumo = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/pagamento/${pay}`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei dati Gas per tipo pagamento:', error);
      throw error;
    }
  }
  
  async getGasDataByAgente(agenteId, consumo = null, typePay = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      if (typePay) params.typePay = typePay;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/agente/${agenteId}`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei dati Gas per agente:', error);
      throw error;
    }
  }
  
  async getGasStatisticheRappresentantiByAgente(agente, consumo = null, typePay = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      if (typePay) params.typePay = typePay;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/statistiche/rappresentanti/${agente}`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero delle statistiche Gas dei rappresentanti per agente:', error);
      throw error;
    }
  }
  
  async getGasGroupedDataByRappresentante(codRapp) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaFatturazione/statistiche/grouped/${codRapp}`);
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei dati Gas raggruppati per rappresentante:', error);
      throw error;
    }
  }

  async getGasStatistichePerMese(consumo = null) {
    try {
      const params = {};
      if (consumo) params.consumo = consumo;
      
      const response = await this.http.get(
        `${this.apiUrl}/AreaFatturazione/statistiche/mese`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero delle statistiche Gas per mese:', error);
      throw error;
    }
  }


  // INIZIO PARTE CHECK NON FATTURATI

  async getCheckNonFatturati() {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaFatturazione/check-non-fatturati`, {
        params: {},
        timeout: 30000
      });
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei POD non fatturati:', error);
      throw error;
    }
  }

  async getCheckNonFatturatiGas() {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaFatturazione/check-non-fatturati-gas`, {
        params: {},
        timeout: 30000
      });
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei PDR non fatturati:', error);
      throw error;
    }
  }


  async getInfoValidazioniFatture() {
    try {
      const response = await this.http.get(`${this.baseUrl}/fornitori/fatturazione/get-info-validazioni-fatture`, { timeout: 30000 });
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero delle info validazioni fatture:', error);
      throw error;
    }
  }

  async getStatisticheValidazioniFatture(params = {}) {
    try {
      const response = await this.http.get(
        `${this.baseUrl}/fornitori/fatturazione/statistiche-validazioni-fatture`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero delle statistiche validazioni fatture:', error);
      throw error;
    }
  }

  async getDettaglioStatisticheValidazioniFatture(params = {}) {
    try {
      const response = await this.http.get(
        `${this.baseUrl}/fornitori/fatturazione/statistiche-validazioni-fatture/dettaglio`,
        { params, timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero del dettaglio statistiche validazioni fatture:', error);
      throw error;
    }
  }


  async getDepositiCauzionali(page = 1, perPage = 50) {
    const url = `${this.baseUrl}/fornitori/fatturazione/get-depositi-cauzionali`;
    let items = [];
    let pagination = {
      current_page: 1,
      per_page: perPage,
      total: 0,
      last_page: 1,
      from: 0,
      to: 0
    };

    try {
      const res = await this.http.get(url, {
        params: { page, per_page: perPage },
        timeout: 30000
      });

      if (res && res.data && res.data.data) {
        const paginated = res.data.data;
        items = Array.isArray(paginated.data) ? paginated.data : [];

        pagination = {
          current_page: paginated.current_page || 1,
          per_page: paginated.per_page || perPage,
          total: paginated.total || items.length,
          last_page: paginated.last_page || 1,
          from: paginated.from || 0,
          to: paginated.to || 0
        };
      }
    } catch (error) {
      console.error('Errore durante il recupero dei depositi cauzionali:', error);
      this.eventBus?.emit?.('data-load-error', { message: error, url });
      items = [];
    } finally {
      this.eventBus?.emit?.('data-loaded');
    }

    return { items, pagination };
  }

  async insertDepositoCauzionale({ used_ft, cod_pod = null, cod_pdr = null } = {}) {
    const url = `${this.baseUrl}/fornitori/fatturazione/insert-deposito-cauzionale`;
    try {
      const payload = {
        used_ft,
        ...(cod_pod ? { cod_pod } : {}),
        ...(cod_pdr ? { cod_pdr } : {})
      };
      const res = await this.http.post(url, payload, { timeout: 30000 });
      return res.data;
    } catch (error) {
      console.error('Errore durante insertDepositoCauzionale:', error);
      this.eventBus?.emit?.('data-load-error', { message: error, url });
      throw error;
    }
  }


  // ROTTE PER FATTURAZIONE EXTRA 

  async getFatturazioneExtra(params = {}) {
    try {
      const response = await this.http.get(
        `${this.baseUrl}/fornitori/fatturazione/fatturazione-extra`,
        { params }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante la chiamata a fatturazione-extra:', error);
      throw error;
    }
  }


  async autocompleteClient(term) {
    const response = await this.http.get(`${this.baseUrl}/fornitori/fatturazione/autocomplete/client`, { params: { term } });
    return response.data;
  }

  async autocompleteFatturaVoci(term) {
    const response = await this.http.get(`${this.baseUrl}/fornitori/fatturazione/autocomplete/fattura-voci`, { params: { term } });
    return response.data;
  }

  async getAllFatturaVoci() {
    try {
      return await this.autocompleteFatturaVoci('');
    } catch (error) {
      console.error('Errore durante il recupero di tutte le voci fattura:', error);
      throw error;
    }
  }

  async autocompletePod(term) {
    const response = await this.http.get(`${this.baseUrl}/fornitori/fatturazione/autocomplete/pod`, { params: { term } });
    return response.data;
  }

  async autocompletePdr(term) {
    const response = await this.http.get(`${this.baseUrl}/fornitori/fatturazione/autocomplete/pdr`, { params: { term } });
    return response.data;
  }

  async getTypePayList() {
    const response = await this.http.get(`${this.baseUrl}/fornitori/fatturazione/type-pay/list`);
    return response.data;
  }

  async checkFatturabileExtraAuto() {
    const response = await this.http.get(`${this.baseUrl}/fornitori/fatturazione/check-fatturabile-extra-auto`);
    return response.data;
  }

  async getContrattiByCliente(codCliente) {
    const response = await this.http.get(`${this.baseUrl}/fornitori/fatturazione/get-contratti-by-cliente`, {
      params: { cod_cliente: codCliente }
    });
    return response.data;
  }

  async getPartitariList() {
    const response = await this.http.get(`${this.baseUrl}/fornitori/fatturazione/partitari/list`);
    return response.data;
  }

  async insertLogFatturazioneExtra(data) {
    try {
      const response = await this.http.post(
        `${this.baseUrl}/fornitori/fatturazione/insert-log-fatturazione-extra`,
        data
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante l\'inserimento del log fatturazione:', error);
      throw error;
    }
  }
}